// LoginTab.js

import { Fragment, useState, useContext, useRef, useEffect } from "react";
import { Form, FormGroup, Input, Label, Container, Row, Col, TabContent, TabPane } from "reactstrap";
import { Btn, P, Image } from "../../../AbstractElements";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowResetPwdScreenValue,
  clearAuthError,
  otpForResetPassword,
  verifyOtp,
  resetPassword,
} from "../../../store/slices/authNewSlice";
import CustomizerContext from "../../../_helper/Customizer";
import DashboardIcon from "../../../assets/images/logo/img1.png";
import CubaIcon from "../../../assets/images/logo/logo.png";
import Swal from "sweetalert2";

const ResetPassword = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const dispatch = useDispatch();

  const { loading, error, errorotpForResetPassword } = useSelector(
    (state) => state.auth
  );

  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const showResetPwdScreen = useSelector(
    (state) => state.auth.showResetPwdScreen
  );
  console.log(showResetPwdScreen, "showResetPwdScreen");

  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const inputRefs = useRef([]);

  const handleChange = (value, idx) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[idx] = value;
    setOtp(newOtp);
    if (value && idx < otp.length - 1) {
      inputRefs.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace") {
      if (otp[idx]) {
        const newOtp = [...otp];
        newOtp[idx] = "";
        setOtp(newOtp);
      } else if (idx > 0) {
        inputRefs.current[idx - 1]?.focus();
      }
    } else if (e.key === "ArrowLeft" && idx > 0) {
      inputRefs.current[idx - 1]?.focus();
    } else if (e.key === "ArrowRight" && idx < otp.length - 1) {
      inputRefs.current[idx + 1]?.focus();
    }
  };

  const handleSendOtp = (e) => {
    e.preventDefault();
    dispatch(otpForResetPassword({ email }))
      .unwrap()
      .then(() => {
        dispatch(setShowResetPwdScreenValue(true));
        setOtp(["", "", "", "", "", ""]);
        setTimer(60);
      })
      .catch((err) => {
        console.error("Failed to send OTP:", err);
      });
  };
  const handleResendOtp = (e) => {
    e.preventDefault();
    dispatch(otpForResetPassword({ email }))
      .unwrap()
      .then(() => {
        dispatch(setShowResetPwdScreenValue(true));
        setOtp(["", "", "", "", "", ""]);
        setTimer(60);
      })
      .catch((err) => {
        console.error("Failed to resend OTP: ", err);
      });
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length !== 6) return;
    dispatch(verifyOtp({ email, otpValue }))
      .unwrap()
      .then((user) => {
        dispatch(setShowResetPwdScreenValue(false));
        setIsOtpVerified(true);
      })
      .catch((err) => {
        console.error("Failed to validate OTP: ", err);
      });
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    console.log("New password:", { email, otpValue, newPassword });
    await dispatch(resetPassword({ email, otpValue, newPassword }))
      .unwrap()
      .then((user) => {
        dispatch(setShowResetPwdScreenValue(false));
        setIsOtpVerified(false);
        Swal.fire({
          title: "Password Reset Successful",
          text: "You will now be redirected to the login page.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          history(`${process.env.PUBLIC_URL}/login`);
        });
      })
      .catch((err) => {
        console.error("Failed to validate OTP: ", err);
      });
  };

  useEffect(() => {
    if (timer === 0) {
      setOtp(["", "", "", "", "", ""]);
      dispatch(clearAuthError());
    }
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (interval !== undefined) {
        clearInterval(interval);
      }
    };
  }, [timer, dispatch]);

  return (
    <Container fluid={true} className="p-0 login-page">
      <Row>
        <Col xs="12">
          <div className="login-card">
            {/* <Image
              attrImage={{
                className: "img-fluid d-inline",
                src: `${DashboardIcon}`,
                alt: "",
                style: { width: "50%", height: "25%" },
              }}
            /> */}
            <div className="login-main login-tab">
              <TabContent className="content-login">
                <TabPane className="fade show">
                  <Fragment>
                    {isOtpVerified && (
                      <>
                        <div className="text-center">
                          <Link
                            to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}
                          >
                            <Image
                              attrImage={{
                                className: "img-fluid d-inline",
                                src: `${CubaIcon}`,
                                alt: "",
                              }}
                            />
                          </Link>
                          <h5 className="mt-3 text-left">Reset Your Password</h5>
                          <h7 className="mt-3 text-left">
                            Please enter your new password below.
                          </h7>
                        </div>
                        <Form
                          className="theme-form"
                          onSubmit={handlePasswordReset}
                        >
                          <FormGroup className="position-relative">
                            <Label
                              className="col-form-label"
                              htmlFor="new-password"
                            >
                              New Password
                            </Label>
                            <div className="position-relative">
                              <Input
                                className="form-control"
                                type={showPassword ? "text" : "password"}
                                id="new-password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                              />
                              <button
                                type="button"
                                className="show-hide"
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label="Toggle password visibility"
                              >
                                <span className={showPassword ? "" : "show"}>
                                  <i
                                    className={`fa ${
                                      showPassword ? "fa-eye-slash" : "fa-eye"
                                    }`}
                                  ></i>
                                </span>
                              </button>
                            </div>
                          </FormGroup>
                          <div className="position-relative form-group mb-0">
                            <Btn
                              attrBtn={{
                                color: "danger",
                                type: "submit",
                                style: { order: 2 },
                              }}
                            >
                              Reset Password
                            </Btn>
                          </div>
                        </Form>
                      </>
                    )}
                    {!isOtpVerified && !showResetPwdScreen && (
                      <>
                        <Form className="theme-form">
                          <div className="text-center">
                            <Link
                              to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}
                            >
                              <Image
                                attrImage={{
                                  className: "img-fluid d-inline",
                                  src: `${CubaIcon}`,
                                  alt: "",
                                }}
                              />
                            </Link>
                            <h5 className="mt-3">Enter Email</h5>
                            <h7 className="mt-3">
                              We'll send a 6-digit OTP to this address.
                            </h7>
                          </div>
                          <FormGroup>
                            <Label className="col-form-label">
                              {"Email Address"}
                            </Label>
                            <Input
                              className="form-control"
                              type="email"
                              onChange={(e) => setEmail(e.target.value)}
                              value={email}
                              style={{ height: "80%" }}
                            />
                          </FormGroup>

                          {errorotpForResetPassword && (
                            <P>{errorotpForResetPassword.message}</P>
                          )}

                          <div className="position-relative form-group mb-0">
                            <Btn
                              attrBtn={{
                                color: "danger",
                                onClick: (e) => handleSendOtp(e),
                                style: { order: 2 },
                                disabled: loading,
                              }}
                            >
                              {loading ? "Sending otp..." : "Send OTP"}
                            </Btn>
                          </div>
                        </Form>
                      </>
                    )}
                    {!isOtpVerified && showResetPwdScreen && (
                      <>
                        <div className="text-center">
                          <Link
                            to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}
                          >
                            <Image
                              attrImage={{
                                className: "img-fluid d-inline",
                                src: `${CubaIcon}`,
                                alt: "",
                              }}
                            />
                          </Link>
                          <h5 className="mt-3">Reset Password OTP</h5>
                        </div>
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (otp.join("").length === 6) {
                              handleSendOtp(e);
                            }
                          }}
                        >
                          <div className="text-center">
                            <h7 className="mt-3">
                              Enter OTP sent to <b>{email}</b>
                            </h7>
                            <div className="flex gap-4 justify-center my-4">
                              {otp.map((digit, idx) => (
                                <input
                                  key={`otp-reset-${idx}-${digit}`}
                                  ref={(el) => (inputRefs.current[idx] = el)}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  className="w-12 h-14 text-center border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100"
                                  value={digit}
                                  onChange={(e) =>
                                    handleChange(e.target.value, idx)
                                  }
                                  onKeyDown={(e) => {
                                    handleKeyDown(e, idx);
                                    if (
                                      e.key === "Enter" &&
                                      otp.join("").length === 6
                                    ) {
                                      handleOtpSubmit(e);
                                    }
                                  }}
                                  autoFocus={idx === 0}
                                  style={{
                                    width: "48px",
                                    height: "64px",
                                  }}
                                />
                              ))}
                            </div>

                            <div className="text-center text-danger">
                              {error && <P>{error.message}</P>}
                            </div>
                            {timer !== 0 && (
                              <div className="text-center text-gray-500 mb-4 text-lg">
                                {`00:${timer.toString().padStart(2, "0")}`}
                              </div>
                            )}
                            <div className="text-center mb-2">
                              {loading ? (
                                <Btn
                                  attrBtn={{
                                    color: "danger",
                                    disabled: "disabled",
                                  }}
                                >
                                  Submitting....
                                </Btn>
                              ) : (
                                <Btn
                                  attrBtn={{
                                    color: "danger",
                                    onClick: (e) => {
                                      handleOtpSubmit(e);
                                    },
                                    disabled: otp.join("").length !== 6,
                                  }}
                                >
                                  Submit
                                </Btn>
                              )}
                            </div>

                            {timer === 0 && (
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "#888",
                                  marginTop: "8px",
                                }}
                              >
                                Didn't receive OTP ?{" "}
                                <button
                                  type="button"
                                  style={{
                                    color: "#6c63ff",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    font: "inherit",
                                  }}
                                  onClick={(e) => handleResendOtp(e)}
                                >
                                  Resend
                                </button>
                              </div>
                            )}
                          </div>
                        </form>
                      </>
                    )}
                    <p className="mt-4">
                      Already have account ? <Link to="/login" className="fw-bold">Login</Link>
                    </p>
                  </Fragment>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;
